import React from "react";

export default function ReviewSection() {
  return (
    <div className="innerDetail">
      <div className="innerDetail__imageWrapper">
        <img
          src="https://ng.jumia.is/cms/external/pet/CU514MT19DMW4NAFAMZ/bea339ed960e069af2e7d9ce8242017f.jpg"
          alt="galaxy a50"
          className="imgProduct"
        />
      </div>
      <br />
      <br />
      <p>
        Porttitor eget dolor morbi non. Euismod lacinia at quis risus sed
        vulputate. Ut placerat orci nulla pellentesque. Eu non diam phasellus
        vestibulum. Feugiat sed lectus vestibulum mattis ullamcorper velit sed
        ullamcorper morbi. Lorem ipsum dolor sit amet. Ac tortor dignissim
        convallis aenean et tortor at. Risus quis varius quam quisque id diam
        vel quam elementum. Morbi tempus iaculis urna id. Urna nunc id cursus
        metus. Tortor condimentum lacinia quis vel eros donec ac. Sit amet
        volutpat consequat mauris. Vitae proin sagittis nisl rhoncus mattis
        rhoncus. Sed risus pretium quam vulputate dignissim suspendisse in.
        Commodo odio aenean sed adipiscing. Venenatis lectus magna fringilla
        urna porttitor rhoncus dolor purus. In tellus integer feugiat
        scelerisque varius morbi enim nunc faucibus.
      </p>
    </div>
  );
}
